<div class="h-full w-full">
  <div class="w-full aligner-between h-[50px] px-3">
    <div class="font-semibold text-standard-heading">Stashed changes</div>
    <button class="close-btn" mat-icon-button mat-dialog-close>
      <fa-icon class="fs-8 text-gray-700" [icon]="['fal', 'times']"></fa-icon>
    </button>
  </div>
  <div class="w-full" style="height: calc(100% - 120px)">
    <y42-logo-loader *ngIf="state.loading.diffs" class="center-absolute" [widthInPixel]="70"> </y42-logo-loader>

    <as-split *ngIf="!state.loading.diffs" [useTransition]="true" [gutterSize]="6" class="border-common">
      <as-split-area [size]="30" [minSize]="10" class="flex flex-col">
        <y42-git-diff-tree
          class="block h-full border-common"
          [changes]="state.diffs"
          [(activeItem)]="activeItem"
        ></y42-git-diff-tree>
      </as-split-area>

      <as-split-area [size]="70" class="flex" [order]="1">
        <div
          *ngIf="state.diffs.length && activeItem"
          class="merge-editor h-full w-full"
          y42MonacoDiffEditor
          [fileName]="activeItem.path"
          [original]="activeItem.fileContents![0]"
          [modified]="activeItem.fileContents![1]"
        ></div>
      </as-split-area>
    </as-split>
  </div>
  <div class="h-[70px] aligner-end">
    <div *ngIf="state.hasChangedFiles" class="mr-2">
      <fa-icon class="fs-13" [icon]="['fal', 'exclamation-triangle']"></fa-icon>
      Unable to restore stash when changes are present on your branch.
    </div>
    <button
      mat-button
      color="warn"
      (click)="discardStash()"
      class="mr-2 border-common w-[110px] h-[42px]"
      [attr.data-test]="'git-stashed-changes-dialog-button-discard'"
    >
      Discard
    </button>
    <button
      mat-raised-button
      color="primary"
      class="mr-2"
      [disabled]="state.hasChangedFiles"
      (click)="restore()"
      [attr.data-test]="'git-stashed-changes-dialog-button-restore'"
    >
      Restore
    </button>
  </div>
</div>
